import { TranslateFunction } from '@/modules/i18n'

export const formatWorkTime = (
  minutes: number | undefined,
  t: TranslateFunction,
  options?: { short?: boolean }
): string => {
  const safeMinutes = Math.max(0, Math.floor(minutes ?? 0))
  const hours = Math.floor(safeMinutes / 60)
  const remainingMinutes = safeMinutes % 60

  if (options?.short) {
    const h = `${hours}${t('common.hourShort')}`
    const m = `${remainingMinutes}${t('common.minuteShort')}`
    if (hours === 0) return m
    if (remainingMinutes === 0) return h
    return `${h} ${m}`
  }

  const formatMinutes = (m: number) =>
    m === 1 ? t('common.oneMinute') : `${m} ${t('common.minutes')}`

  const formatHours = (h: number) => {
    if (h === 1) return t('common.oneHour')
    if (h === 2) return t('common.twoHours')
    return `${h} ${t('common.hours')}`
  }

  if (hours === 0) {
    return formatMinutes(remainingMinutes)
  }
  if (remainingMinutes === 0) {
    return formatHours(hours)
  }
  return `${formatHours(hours)}${t('common.andTime', { time: formatMinutes(remainingMinutes) })}`
}
